import { QuickLink } from './quick-link';
import _ from 'lodash';

export class QuickLinksMap {

    genericQuickLinks: Map<number, Array<QuickLink>>;
    eSquirrelQuickLinks: Map<number, Array<QuickLink>>;
    gmtQuickLinks: Map<number, Array<QuickLink>>;
    hsmQuickLinks: Map<number, Array<QuickLink>>;
    digiFitQuicklinks: Map<number, Array<QuickLink>>;

    constructor() {
        this.genericQuickLinks = new Map<number, Array<QuickLink>>();
        this.eSquirrelQuickLinks = new Map<number, Array<QuickLink>>();
        this.gmtQuickLinks = new Map<number, Array<QuickLink>>();
        this.hsmQuickLinks = new Map<number, Array<QuickLink>>();
        this.digiFitQuicklinks = new Map<number, Array<QuickLink>>();
    }

    /**
     * Returns true if the object contains at least one quicklink.
     * @returns {boolean}
     */
    hasQuickLinks(): boolean {
        return (this.genericQuickLinks.size +
            this.eSquirrelQuickLinks.size +
            this.digiFitQuicklinks.size +
            this.gmtQuickLinks.size +
            this.hsmQuickLinks.size) > 0;
    }

    addToMap(quickLink: QuickLink, map: Map<number, Array<QuickLink>>): void {

        if (map.has(quickLink.pageId)) {
            map.get(quickLink.pageId)
                .push(quickLink);
        } else {
            map.set(quickLink.pageId, [quickLink]);
        }
    }

    flatten(map: Map<number, Array<QuickLink>>): Array<QuickLink> {
        return _.flatten(Array.from(map.values()));
    }

}
